/** True when the loaded document is a 2D F2D sheet (plan/elevation). */
export function is2dViewer(viewer: Autodesk.Viewing.GuiViewer3D): boolean {
  try {
    return viewer.model?.is2d?.() === true;
  } catch {
    return false;
  }
}
